import { Dialog, Box, Typography, CircularProgress, Button } from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface Props {
    open: boolean;
    message: string;
    error: boolean;
    sucess: boolean;
    setOpenLoader: React.Dispatch<React.SetStateAction<boolean>>;
    setShowErroIcon: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function RegistrationLoader({ open, message, error, sucess, setOpenLoader, setShowErroIcon }: Props) {
    return (
        <Dialog open={open} fullWidth maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                p={5}
                textAlign="center"
            >

                {error ? <ErrorOutlineIcon sx={{ fontSize: 60, color: 'red' }} />
                    : (sucess ? <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'green' }} />
                        : <CircularProgress size={60} />)
                }

                <Typography variant="body1" mt={3}>
                    {message}
                </Typography>

                <Typography variant="body2" color="text.secondary" mt={20}>
                    {!sucess ? `Please do not close this tab while setup completes.` : ''}
                </Typography>

                {sucess && (
                    <Button
                        autoCapitalize={'none'}
                        variant='contained'
                        onClick={() => {
                            setOpenLoader(false)
                        }}
                        sx={{ whiteSpace: 'nowrap', alignSelf: 'flex-end', marginTop: '5%' }}
                    >
                        Close
                    </Button>
                )}

                {error && (
                    <Button
                        autoCapitalize={'none'}
                        variant='contained'
                        onClick={() => {
                            setOpenLoader(false)
                            setShowErroIcon(false);
                        }}
                        sx={{ whiteSpace: 'nowrap', alignSelf: 'flex-end', marginTop: '5%' }}
                    >
                        Ok
                    </Button>
                )}


            </Box>
        </Dialog>
    );
}